var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 178.2 153.344"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.929 33.488l-57.133 97.6h107.118z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.063 30.1l1.187-1.385 46.25 90.3L99.574 0H78.947L6.084 126.533z",
    fill: "#5ac827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.684 10.363l37.915 123.194H46.127l110.531 17.758 12.416 1.929 9.126-15.977z",
    fill: "#006837"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.039 42.046L0 137.391l9.671 15.955H153.64l-125-20.083z",
    fill: "#8cc63f"
  })));
}
export default SvgLogo;